/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetAwsIamCredentialSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type GetAwsIamCredentialRequest = {
  /**
   * The ID of the credential to get.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type GetAwsIamCredentialSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetAwsIamCredentialSecurity$outboundSchema: z.ZodMiniType<
  GetAwsIamCredentialSecurity$Outbound,
  GetAwsIamCredentialSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getAwsIamCredentialSecurityToJSON(
  getAwsIamCredentialSecurity: GetAwsIamCredentialSecurity,
): string {
  return JSON.stringify(
    GetAwsIamCredentialSecurity$outboundSchema.parse(
      getAwsIamCredentialSecurity,
    ),
  );
}

/** @internal */
export type GetAwsIamCredentialRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const GetAwsIamCredentialRequest$outboundSchema: z.ZodMiniType<
  GetAwsIamCredentialRequest$Outbound,
  GetAwsIamCredentialRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function getAwsIamCredentialRequestToJSON(
  getAwsIamCredentialRequest: GetAwsIamCredentialRequest,
): string {
  return JSON.stringify(
    GetAwsIamCredentialRequest$outboundSchema.parse(getAwsIamCredentialRequest),
  );
}
